import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var Check = function Check(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04777 9.5C4.52095 9.5 4.8879 9.33101 5.13898 8.96406L9.56172 2.44582C9.73554 2.18991 9.8128 1.92436 9.8128 1.68777C9.8128 1.0118 9.27202 0.5 8.57674 0.5C8.1084 0.5 7.79938 0.668991 7.51451 1.11803L4.02846 6.52575L2.32406 4.61856C2.08265 4.34335 1.79295 4.21298 1.40668 4.21298C0.706572 4.21298 0.189941 4.72479 0.189941 5.40558C0.189941 5.71942 0.272023 5.96084 0.537581 6.26019L3.01451 9.05579C3.28973 9.36481 3.62771 9.5 4.04777 9.5Z"
  }));
};

Check.displayName = 'Check';
export default Check;